import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faEnvelope, faSpinner } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import {
  CommonSuccessMessages,
  CommonValidationMessages,
} from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { components } from "react-select";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import moment from "moment";
import ActionDropdown from "../../components/dropdown/ActionDropdown.js";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          className="inputFocus"
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};
class InquiryEntry extends Component {
  constructor(props) {
    super(props);
    this.inventoryServices = new InventoryServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      rawMaterialList: [],
      packingMaterialDropDownList: [],
      partyDropdownList: [],
      inquiryDetailList: [],
      inquiryMaterialDetailsList: [],
      isMaterialDetailsHide: true,
      isMaterialDetailsEditing: false,
      isInquiryDetailsHide: false,
      tableStatus: "",
      isLoading: false,
      typeList: [{ grnType: "Raw" }, { grnType: "Packing" }],
      statusList: [{ status: "Inquiry Created" }, { status: "Email Sent" }],
      filterDetails: {
        inquiryNo: "",
        inquiryDate: "",
        materialType: "",
        status: "",
      },
      inquiryEntryDetails: {
        inquiryId: "",
        selectedParty: [],
        materialType: "",
        status: "",
      },
      inquiryMaterialDetails: {
        inquiryMaterialDetailsId: "",
        rawMaterialId: "",
        packageMaterialId: "",
        qty: 0,
        uom: "",
        remarks: "",
      },
      validationRules: {
        selectedParty: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        materialType: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "material type"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRulesForMaterials: {
        qty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "qty"
            ),
          },
        ],
        // uom: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "uom"
        //     ),
        //   },
        // ],
      },
      rawMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "raw material"
          ),
        },
      ],
      packageMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "package material"
          ),
        },
      ],
      validStateForMaterials: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getallInquiryDetails();
  }

  getallInquiryDetails = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.inventoryServices.getallInquiryDetails(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let res = response.responseData;
        let responseList = res.map((inquiry) => {
          let partyDetails = inquiry.partyIds;

          let array = partyDetails.split(",");
          const options = [];
          array.forEach((topic) => {
            const foundItem = this.state.partyDropdownList.find(
              (topics) => topics.value === topic
            );
            if (foundItem) {
              options.push(foundItem);
            }
          });

          inquiry.selectedParty = options;
          if (options.length > 0) {
            var arr1 = options.map(function (item) {
              const { bad, label } = item;
              return label;
            });
            inquiry.partyNames = arr1.join(",");
          }
          return inquiry;
        });
        this.setState({ inquiryDetailList: responseList }, () => {
          this.getAllPartyDropdown();
        });
      } else {
        this.setState({ tableStatus: "" })
        this.getAllPartyDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };
  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
          email: item.email,
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getAllRMDropdown();
        });
      } else {
        this.getAllRMDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };


  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM,
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown();
        });
      } else {
        this.getAllPackingMaterialDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM,
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems }, () => { });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.setState({ isGridView: true, isEditing: false });
  };

  handleDropdownChange = (e, name, section) => {
    const value = e.target.value;
    if (section === "FilterDetails") {
      let detail = this.state.filterDetails;
      detail[name] = value;
      this.setState({ filterDetails: detail }, () => {
        this.getallInquiryDetails();
      });
    } else {
      let details = this.state.inquiryEntryDetails;
      details[name] = value;
      this.setState({ inquiryEntryDetails: details }, () => {
        this.isAllFieldsValidate();
      });
    }
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    let details = this.state.inquiryMaterialDetails;
    let details2 = this.state.filterDetails;
    if (section === "FilterDetails") {
      details2[name] = value.toUpperCase();
      this.setState({ filterDetails: details2 }, () => {
        this.getallInquiryDetails();
      });
    } else {
      details[name] = value.toUpperCase();
      this.setState({ inquiryMaterialDetails: details });
    }
  };

  setFilterParameters = (selected, drpIdentity, section) => {
    let details = this.state.inquiryEntryDetails;
    let detail1 = this.state.inquiryMaterialDetails;
    if (section === "MaterialDetails") {
      detail1[drpIdentity] = selected.value;
      detail1.uom = selected.uom;
      this.setState({ inquiryMaterialDetails: detail1 });
    } else {
      details[drpIdentity] = selected.value;
      details.email = selected.email;
      this.setState({ inquiryEntryDetails: details }, () => {
        this.isAllFieldsValidate();
      });
    }
  };

  setFilterParametersMulti = (selected, drpIdentity) => {
    let details = this.state.inquiryEntryDetails;
    details[drpIdentity] = selected;
    this.setState({ inquiryEntryDetails: details }, () => {
      this.isAllFieldsValidate();
    });
  };

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.inquiryEntryDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    if (newValidState.isValid) {
      this.setState({ isMaterialDetailsHide: false });
    } else {
      this.setState({ isMaterialDetailsHide: true });
    }
  };

  isValidAllFields = () => {
    const validationRule = this.state.validationRulesForMaterials;

    if (this.state.inquiryEntryDetails.materialType === "Raw") {
      validationRule.rawMaterialId = this.state.rawMaterialIdRule;
    } else {
      validationRule.packageMaterialId = this.state.packageMaterialIdRule;
    }

    const newValidState = isValidForm(
      this.state.inquiryMaterialDetails,
      validationRule,
      this.state.validStateForMaterials
    );
    this.setState({ validStateForMaterials: newValidState });
    return newValidState.isValid;
  };

  addEditInquiryDetails = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = {};
        request.inquiryEntryDetails = this.state.inquiryEntryDetails;
        if (request.inquiryEntryDetails.status === "") {
          request.inquiryEntryDetails.status = "Inquiry Created";
        }
        request.inquiryMaterialDetails = this.state.inquiryMaterialDetails;

        if (request.inquiryEntryDetails.selectedParty.length > 0) {
          var arr1 = request.inquiryEntryDetails.selectedParty.map(function (
            item
          ) {
            delete item.bad;
            return item.value;
          });
          request.inquiryEntryDetails.partyIds = arr1.join([","]);
        }

        if (this.state.inquiryEntryDetails.materialType === "Raw") {
          delete request.inquiryMaterialDetails.packageMaterialId;
        } else {
          delete request.inquiryMaterialDetails.rawMaterialId;
        }

        if (request.inquiryEntryDetails.inquiryId === "") {
          delete request.inquiryEntryDetails.inquiryId;
        }

        if (request.inquiryMaterialDetails.inquiryMaterialDetailsId === "") {
          delete request.inquiryMaterialDetails.inquiryMaterialDetailsId;
        }

        this.inventoryServices.addEditInquiryDetails(request).then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.responseData.Message);
            let details = this.state.inquiryEntryDetails;
            details.inquiryId = response.responseData.inquiryEntryDetails._id;
            this.setState({ inquiryEntryDetails: details }, () => {
              this.SwalServices.Success(response.Message);
              this.resetMaterialDetalis();
              this.getAllInquiryMaterialDetailsByInquiryId(
                this.state.inquiryEntryDetails.inquiryId
              );
              this.setState({ isLoading: false, isMaterialDetailsEditing: false })
            });
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false, isMaterialDetailsEditing: false })
          }
        });
      })
    }
  };


  resetFilterDetails = () => {
    let filterDetails = this.state.filterDetails
    filterDetails.inquiryNo = "";
    filterDetails.inquiryDate = "";
    filterDetails.materialType = "";
    filterDetails.status = "";
    this.setState({ filterDetails: filterDetails })
  }

  resetMaterialDetalis = () => {
    let validStateForMaterials = this.state.validStateForMaterials
    validStateForMaterials.isValid = "true";
    validStateForMaterials.error = {};
    let details = this.state.inquiryMaterialDetails;
    details.inquiryMaterialDetailsId = "";
    details.rawMaterialId = "";
    details.packageMaterialId = "";
    details.qty = 0;
    details.uom = "";
    details.remarks = "";
    this.setState({ inquiryMaterialDetails: details, validStateForMaterials: validStateForMaterials, isMaterialDetailsEditing: false });
  };

  resetInquiryDetalis = () => {
    let validState = this.state.validState;
    validState.isValid = "false"
    validState.error = {}
    let details = this.state.inquiryEntryDetails;
    details.inquiryId = "";
    details.selectedParty = [];
    details.materialType = "";
    this.setState({
      inquiryEntryDetails: details,
      inquiryMaterialDetailsList: [],
      validState: validState
    });
  };
  resetFormAndOpenGrid = () => {
    this.resetFilterDetails();
    this.resetMaterialDetalis();
    this.resetInquiryDetalis();
    this.setState({ isGridView: true, isMaterialDetailsHide: true, isEditing: false, tableStatus: "" }, () => {
      this.getallInquiryDetails();
    })
  };

  editInquiryDetails = (materialDetail) => {
    let details = this.state.inquiryEntryDetails;
    details.inquiryId = materialDetail._id;
    details.selectedParty = materialDetail.selectedParty;
    details.materialType = materialDetail.materialType;
    details.status = materialDetail.status ? materialDetail.status : "";
    this.setState({ inquiryEntryDetails: details }, () => {
      this.getAllInquiryMaterialDetailsByInquiryId(materialDetail._id);
    });
  };

  getAllInquiryMaterialDetailsByInquiryId = (id) => {
    this.inventoryServices
      .getAllInquiryMaterialDetailsByInquiryId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = response.responseData;
          this.setState({ inquiryMaterialDetailsList: details }, () => {
            this.isAllFieldsValidate();
            this.setState({ isGridView: false, isInquiryDetailsHide: true });
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };



  getInquiryMaterialEntryById = (inquiry) => {
    this.setState({ isMaterialDetailsEditing: true })
    let details = this.state.inquiryMaterialDetails;
    details.inquiryMaterialDetailsId = inquiry._id;
    details.rawMaterialId = inquiry.rawMaterialId
      ? inquiry.rawMaterialId._id
      : "";
    details.packageMaterialId = inquiry.packageMaterialId
      ? inquiry.packageMaterialId._id
      : "";
    details.qty = inquiry.qty;
    details.uom = inquiry.rawMaterialId
      ? inquiry.rawMaterialId.rmUOM
      : inquiry.packageMaterialId.pmUOM;
    details.remarks = inquiry.remarks;
    this.setState({ inquiryMaterialDetails: details });
  };

  deleteInquiryDetailsById = (id) => {
    this.inventoryServices.deleteInquiryDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.getallInquiryDetails();
        this.SwalServices.Success(response.Message);
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  deleteInquiryMaterialDetailsById = (id) => {
    this.inventoryServices
      .deleteInquiryMaterialDetailsById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          this.getAllInquiryMaterialDetailsByInquiryId(
            this.state.inquiryEntryDetails.inquiryId
          );
          this.SwalServices.Success(response.Message);
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  sendEmail = (inquiry) => {
    let selectedCompany = inquiry.selectedParty;
    let email = selectedCompany.filter(
      (x) => x.email === "" || x.email === null
    );
    if (email.length > 0) {
      const companiesList = email.map((x) => `<li>${x.label}</li>`).join("");
      this.SwalServices.Confirm(
        "Do you wish to proceed?",
        ``,
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text,
        `<br>The following companies have no email ID:<br><ul>${companiesList}</ul>Do you wish to proceed without them?`
      ).then((response) => {
        if (response === true) {
          let companies = selectedCompany.filter((x) => x.email !== "");
          inquiry.selectedParty = companies;
          this.sendInquiryToCompany(inquiry);
        }
      });
    } else {
      this.sendInquiryToCompany(inquiry);
    }
  };

  sendInquiryToCompany = (inquiryDetails) => {
    let request = {
      inquiryId: inquiryDetails._id,
      companies: inquiryDetails.selectedParty,
    };
    this.inventoryServices.sendInquiryToCompany(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.getallInquiryDetails();
        this.SwalServices.Success(response.Message);
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  onClickHandlers = (buttonType, item) => {
    if (buttonType === "edit") {
      this.editInquiryDetails(item);
    }
    if (buttonType === "delete") {
      this.deleteInquiryDetailsById(item._id);
    }
    if (buttonType === "sendEmail") {
      this.sendEmail(item);
    }
  };

  render() {
    const options = ["edit", "delete", "sendEmail"];
    return (
      <div className="inquiryEntry-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search mb-3.5">
              <div className="item-grp flex gap-2.5 mb-3.5">
                <div className="item-search-box !w-full">
                  <label>Inquiry No</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="inquiryNo"
                    name="inquiryNo"
                    autoComplete="off"
                    value={this.state.filterDetails.inquiryNo}
                    onChange={(event) =>
                      this.handleChange(event, "inquiryNo", "FilterDetails")
                    }
                  />
                </div>
                <div className="item-search-box !w-full">
                  <label>Date</label>
                  <input
                    className="inputFocus"
                    type="date"
                    id="inquiryDate"
                    name="inquiryDate"
                    autoComplete="off"
                    value={this.state.filterDetails.inquiryDate}
                    onChange={(event) =>
                      this.handleChange(event, "inquiryDate", "FilterDetails")
                    }
                  />
                </div>
                <div className="dropdown-grp !w-full">
                  <label>Material Type</label>
                  <select
                    name="materialType"
                    value={this.state.filterDetails.materialType}
                    onChange={(e) =>
                      this.handleDropdownChange(
                        e,
                        "materialType",
                        "FilterDetails"
                      )
                    }
                  >
                    <option>Select</option>
                    {this.state.typeList.map((x, key) => (
                      <option key={key} value={x.grnType}>
                        {x.grnType}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="dropdown-grp !w-full">
                  <label>Status</label>
                  <select
                    name="status"
                    value={this.state.filterDetails.status}
                    onChange={(e) =>
                      this.handleDropdownChange(e, "status", "FilterDetails")
                    }
                  >
                    <option>Select</option>
                    {this.state.statusList.map((x, key) => (
                      <option key={key} value={x.status}>
                        {x.status}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <button className="add-btn" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                <table className="itemList">
                  <thead style={{ zIndex: "10" }}>
                    <tr>
                      <td style={{ width: "10%" }}>Inquiry No</td>
                      <td style={{ width: "10%" }}>Date</td>
                      <td style={{ width: "42%" }}>Party Name</td>
                      <td style={{ width: "10%" }}>Status</td>
                      <td style={{ width: "13%", textAlign: "center" }}>
                        Action
                      </td>
                    </tr>
                  </thead>
                  {this.state.inquiryDetailList &&
                    this.state.inquiryDetailList.length > 0 ? (
                    this.state.inquiryDetailList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.inquiryNo}</td>
                          <td>
                            {moment(item.inquiryDate).format("DD MMM yyyy")}
                          </td>
                          <td>{item.partyNames}</td>
                          <td>{item.status ? item.status : ""}</td>
                          <td style={{ textAlign: "center" }}>
                            {/* <button
                          className="search-btn"
                          onClick={() => this.editInquiryDetails(item)}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                        <button
                          className="cancel-btn"
                          onClick={() =>
                            this.deleteInquiryDetailsById(item._id)
                          }
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <button
                          className="mail-btn"
                          onClick={() => this.sendEmail(item)}
                          style={{ marginLeft: "8px" }}
                        >
                          <FontAwesomeIcon icon={faEnvelope} />
                        </button> */}
                            <ActionDropdown
                              options={options}
                              item={item}
                              onClickHandle={this.onClickHandlers.bind(this)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.inquiryDetailList &&
                    this.state.inquiryDetailList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.inquiryDetailList &&
                    this.state.inquiryDetailList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table !mb-4">
                <div className="item-grp !gap-2.5">
                  <div className="item-inner-grp mb-3 flex gap-2.5">
                    <div className="input-grp" style={{ width: "50%" }}>
                      <label>Party Name</label>
                      <MultiSelectDropdown
                        drpIdentity="selectedParty"
                        options={this.state.partyDropdownList}
                        isMulti
                        // components={{
                        //   Option
                        // }}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                          this.setFilterParametersMulti(
                            selected,
                            "selectedParty"
                          )
                        }
                        allowSelectAll={false}
                        value={this.state.inquiryEntryDetails.selectedParty}
                        isDisabled={this.state.isInquiryDetailsHide}
                      />
                    </div>
                    <div className="dropdown-grp" style={{ width: "20%" }}>
                      <label>Material Type</label>
                      <select
                        name="materialType"
                        disabled={this.state.isInquiryDetailsHide}
                        // className={`${this.state.isInquiryDetailsHide ? "disable-input" : ""
                        //   }`}
                        value={this.state.inquiryEntryDetails.materialType}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "materialType")
                        }
                      >
                        <option>Select</option>
                        {this.state.typeList.map((x, key) => (
                          <option key={key} value={x.grnType}>
                            {x.grnType}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="item-inner-grp mb-3.5 flex gap-2.5">
                    <div className="input-grp" style={{ width: "30%" }}>
                      <label>Product Name</label>
                      {this.state.inquiryEntryDetails.materialType === "Raw" ? (
                        <>
                          <MultiSelectDropdown
                            className={` ${this.state.validStateForMaterials?.error?.rawMaterialId ? "errorInput" : ""}`}
                            drpIdentity="rawMaterialId"
                            options={this.state.rawMaterialList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                              this.setFilterParameters(
                                selected,
                                "rawMaterialId",
                                "MaterialDetails"
                              )
                            }
                            allowSelectAll={false}
                            value={this.state.rawMaterialList.filter(
                              (party) =>
                                party.value ===
                                this.state.inquiryMaterialDetails.rawMaterialId
                            )}
                            isDisabled={this.state.isMaterialDetailsHide}
                          />
                          {/* <ValidationText
                            error={
                              this.state.validStateForMaterials.error
                                .rawMaterialId
                            }
                          /> */}
                        </>
                      ) : (
                        <>
                          <MultiSelectDropdown
                            className={` ${this.state.validStateForMaterials?.error?.packageMaterialId ? "errorInput" : ""}`}
                            drpIdentity="packageMaterialId"
                            options={this.state.packingMaterialDropDownList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                              this.setFilterParameters(
                                selected,
                                "packageMaterialId",
                                "MaterialDetails"
                              )
                            }
                            allowSelectAll={false}
                            value={this.state.packingMaterialDropDownList.filter(
                              (party) =>
                                party.value ===
                                this.state.inquiryMaterialDetails
                                  .packageMaterialId
                            )}
                            isDisabled={this.state.isMaterialDetailsHide}
                          />
                          {/* <ValidationText
                            error={
                              this.state.validStateForMaterials.error
                                .packageMaterialId
                            }
                          /> */}
                        </>
                      )}
                    </div>
                    <div
                      className="input-grp"
                      style={{ width: "20%", display: "flex", gap: "10px" }}
                    >
                      <div className="double-grp">
                        <label>UOM</label>
                        <input
                          //  className={` ${this.state.validStateForMaterials?.error?.rawMaterialId  ? "errorInput" : ""}`}
                          type="text"
                          id="uom"
                          name="uom"
                          autoComplete="off"
                          disabled
                          value={this.state.inquiryMaterialDetails.uom}
                          onChange={(event) => this.handleChange(event, "uom")}
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.uom}
                        /> */}
                      </div>
                      <div className="double-grp">
                        <label>Quantity</label>
                        <input
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.qty ? "errorInput" : ""}`}
                          type="number"
                          id="qty"
                          name="qty"
                          autoComplete="off"
                          disabled={this.state.isMaterialDetailsHide}
                          // className={`inputFocus ${this.state.isMaterialDetailsHide
                          //   ? "disable-input"
                          //   : ""
                          //   }`}
                          value={this.state.inquiryMaterialDetails.qty}
                          onChange={(event) => this.handleChange(event, "qty")}
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.qty}
                        /> */}
                      </div>
                    </div>
                    <div className="input-grp" style={{ width: "50%" }}>
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="remarks"
                        name="remarks"
                        autoComplete="off"
                        disabled={this.state.isMaterialDetailsHide}
                        // className={`inputFocus ${this.state.isMaterialDetailsHide
                        //   ? "disable-input"
                        //   : ""
                        //   }`}
                        value={this.state.inquiryMaterialDetails.remarks}
                        onChange={(event) =>
                          this.handleChange(event, "remarks")
                        }
                      />
                    </div>
                  </div>

                  <div className="btn-grp">
                    {/* {this.state.isMaterialDetailsEditing ? (
                      <button
                        disabled={
                          this.state.isMaterialDetailsHide}
                        // className={`${this.state.isMaterialDetailsHide
                        //   ? "disable-button"
                        //   : ""
                        //   } add-btn`}
                        className="add-btn"
                        onClick={() => this.addEditInquiryDetails()}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        disabled={
                          this.state.isMaterialDetailsHide
                        }
                        // className={`${this.state.isMaterialDetailsHide
                        //   ? "disable-button"
                        //   : ""
                        //   } add-btn`}
                        className="add-btn"
                        onClick={() => this.addEditInquiryDetails()}
                      >
                        Add
                      </button>
                    )} */}
                    {this.state.isMaterialDetailsEditing === true ? (
                      <button
                        className="add-btn"
                        disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                        onClick={() => this.addEditInquiryDetails()}
                      >
                        {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                      </button>
                    ) : (
                      <button
                        className="add-btn"
                        disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                        onClick={() => this.addEditInquiryDetails()}
                      >
                        {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                      </button>
                    )}
                    <button
                      disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                      // className={`${this.state.isMaterialDetailsHide ? "disable-button" : ""
                      //   } cancel-btn !ml-0`}
                      className="cancel-btn !ml-0"

                      onClick={() => this.resetMaterialDetalis()}
                    >
                      Cancel
                    </button>
                    <button
                      className="back-btn"
                      onClick={() => this.resetFormAndOpenGrid()}
                      disabled={this.state.isLoading}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
              <div className="innerTable" >
                <div className="innerTable-container" style={{ height: "calc(100vh - 260px)" }}>
                  <table className="innerList">
                    <thead>
                      <tr>
                        <td style={{ width: "35%" }}>Item Name</td>
                        <td style={{ width: "10%" }}>Unit</td>
                        <td style={{ width: "10%" }}>Quantity</td>
                        <td style={{ width: "10%", textAlign: "center" }}>
                          Action
                        </td>
                      </tr>
                    </thead>
                    {this.state.inquiryMaterialDetailsList &&
                      this.state.inquiryMaterialDetailsList.length > 0 ? (
                      this.state.inquiryMaterialDetailsList.map(
                        (inquiry, key) => (
                          <tbody key={key}>
                            <tr>
                              <td>
                                {inquiry.rawMaterialId
                                  ? inquiry.rawMaterialId.rmName
                                  : inquiry.packageMaterialId.pmName}
                              </td>
                              <td>
                                {inquiry.rawMaterialId
                                  ? inquiry.rawMaterialId.rmUOM
                                  : inquiry.packageMaterialId.pmUOM}
                              </td>
                              <td>{inquiry.qty}</td>
                              <td style={{ textAlign: "center" }}>
                                <button
                                  className="search-btn"
                                  onClick={() =>
                                    this.getInquiryMaterialEntryById(inquiry)
                                  }
                                >
                                  <FontAwesomeIcon icon={faPen} />
                                </button>
                                <button
                                  className="cancel-btn"
                                  onClick={() =>
                                    this.deleteInquiryMaterialDetailsById(
                                      inquiry._id
                                    )
                                  }
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        )
                      )
                    ) :
                      null
                    }
                  </table>
                </div>
              </div>

            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default InquiryEntry;
